{
    "page_title__customers": "Clients",
    "page_sub_title__customers": "Ici, vous trouvez lesquels de vos clients ont besoin d'un rendez-vous en priorité. Vous voyez les clients dont vous êtes responsable, avec leurs chiffres et leur statut comme dans votre ERP. Les vues rapides ci-dessus sont des listes toutes prêtes pour cela.",
    "quick_filters__customers_my_plus_customers": "🚀 Plus fort potentiel de développement",
    "quick_filters__customers_my_minus_customers": "⚠️ Risque d'attrition le plus élevé",
    "filter_menu_title__sales_rep": "Commercial",
    "filter_menu_title__city": "Ville",
    "filter_menu_title__zip_code": "Code postal",
    "filter_menu_title__industry": "Secteur",
    "filter_menu_title__insights": "Recommandations commerciales",
    "filter_menu_title__status": "Statut",
    "filter_menu_title__company": "Site de vente",
    "filter_menu_title__customer_class": "Type de client",
    "filter_menu_title__sales_region": "Région de vente",
    "filter_menu_title__customer": "Client",
    "customer_search_placeholder": "Rechercher nom, n° client, CP, ville",
    "table_header__name": "Client",
    "table_header__ttm_current": "Chiffre d'affaires 12 mois",
    "table_header__order_sum_ttm_current": "Montant des commandes 12 mois",
    "table_header__ttm_delta": "Écart 12 mois",
    "table_header__revenue_ytd": "Chiffre d'affaires année en cours",
    "table_header__order_sum_ytd": "Montant des commandes année en cours",
    "table_header__revenue_ytd_delta": "Écart année en cours",
    "table_header__last_order_date": "Dernière commande",
    "table_header__primary_rep": "Commercial principal",
    "table_header__city": "Ville",
    "table_header__industry": "Secteur",
    "table_header__status": "Statut",
    "table_header__expansion_potential": "Plus fort potentiel de développement",
    "table_header__revenue_decline": "Attrition",
    "table_header__gm_ttm": "Marge 12 mois",
    "table_header__gm_ttm_percent": "Marge % 12 mois",
    "table_header__gm_ttm_delta": "Écart marge 12 mois",
    "table_header__gm_ytd": "Marge année en cours",
    "table_header__gm_ytd_percent": "Marge % année en cours",
    "table_header__gm_ytd_delta": "Écart marge année en cours",
    "status_new": "Nouveau",
    "status_active": "Actif",
    "status_at_risk": "À risque",
    "status_inactive": "Inactif",
    "status_blocked": "Bloqué",
    "status_dormant": "En sommeil",
    "status_tooltip": "Plato vous aide à prioriser vos clients. Plato déduit les quatre premiers statuts de l'activité de commande et des signaux de risque :",
    "status_tooltip_new": "vient de commencer à commander",
    "status_tooltip_active": "commande régulièrement",
    "status_tooltip_at_risk": "montre des signaux d'attrition",
    "status_tooltip_dormant": "aucune commande depuis plus de 6 mois",
    "status_tooltip_inactive": "marqué inactif dans Plato, réversible dans Plato. Aucune recommandation",
    "status_tooltip_blocked": "bloqué dans l'ERP, modifiable uniquement dans l'ERP. Aucune recommandation",
    "table_footer__sum": "Total",
    "table_header__visit_count": "Visites documentées",
    "table_header__visits_per_100k": "Visites / 100 k€",
    "visits_per_100k_tooltip": "Nombre de visites pour 100 k€ de chiffre d'affaires sur les 12 derniers mois. Indique si l'effort de visite correspond à la taille du client — utile pour repérer les petits clients qui absorbent beaucoup de visites et les grands clients trop peu visités. Les visites enregistrées comme « client non joint » ne comptent pas. Calculé uniquement pour les clients réalisant au moins 1 k€ de chiffre d'affaires.",
    "table_header__last_visit": "Dernière visite",
    "last_visit_tooltip": "Date de la visite la plus récente chez ce client."
}
